import styled from 'styled-components'
import { Grid, Glyphicon } from 'react-bootstrap'
import { useKendra } from '../../hooks'
import _ from 'lodash'

const Container = styled.div`
  background: var(--white);
  padding: 10px 0;
  margin-bottom: 30px;
  border-bottom: 1px solid #efefef;
`
const Icon = styled.span`
  margin-right: 15px;
`
const Value = styled.span`
  font-weight: 600;
`

/**
 * Breadcrumbs component to display the current navigation path.
 *
 * Shows the content type, title, and device name for classic ESSearch.
 * Shows the search query for Kendra.
 *
 * @param {Object} props - The component props.
 * @param {string} props.contentType - The type of content being displayed.
 * @param {string} props.title - The title of the current page.
 * @param {Object} props.device - The device information.
 * @param {string} props.device.name - The name of the device.
 * @returns {JSX.Element} The rendered breadcrumbs component.
 */
const Breadcrumbs = ({ contentType, title, device }) => {
  const { isKendraEnabled, search } = useKendra()
  return (
    <Container>
      <Grid>
        <Icon>
          <Glyphicon glyph="search" />
        </Icon>
        {isKendraEnabled ? (
          <>
            <span>{!_.isEmpty(search.error?.message) ? 'Error' : 'Search results: '}</span>
            {!_.isEmpty(search.error?.message) ? (
              <Value>{search.error?.message || search.error?.code}</Value>
            ) : search.dataReady ? (
              <Value>{search.queryText}</Value>
            ) : (
              <Value>{title}</Value>
            )}
          </>
        ) : (
          <>
            <span>Search results: </span>
            {contentType && (
              <>
                <Value>{contentType}</Value>
                <span> / </span>
              </>
            )}
            <Value>{title}</Value>
            {device && <Value> ({device.name})</Value>}
          </>
        )}
      </Grid>
    </Container>
  )
}

export default Breadcrumbs
